export default __webpack_public_path__ + "static/media/01_Jelen_evropsky_lesni_Saj_cmmj_thumb-min.b8e01a15.jpg";